import { useState, useEffect } from 'react';
import { ZoomIn } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import ContactSection from '../components/ContactSection';
import GalleryLightboxModal from '../components/GalleryLightboxModal';
import { SITE_INFO, FALLBACK_SERVICES } from '../data';
import { fetchCollection } from '../lib/cms';

export default function GalleryPage() {
  const [galleries, setGalleries] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('alle');
  const [allImages, setAllImages] = useState([]);

  // Lightbox State
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeImgIndex, setActiveImgIndex] = useState(0);

  useEffect(() => {
    async function loadGalleries() {
      const cmsGalleries = await fetchCollection('galleries');
      if (cmsGalleries && cmsGalleries.length > 0) {
        setGalleries(cmsGalleries);
      } else {
        // Fallback gallery items
        const fallbackGals = [
          {
            name: "Tagarbejde & Kviste",
            service_slug: "tagarbejde",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_f493eae0.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00022.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_2e2a5817.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_e96d2292.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_9717014f.jpeg"
            ]
          },
          {
            name: "Døre & Vinduer",
            service_slug: "doere-og-vinduer",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_80f10c1c.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_8a3b0b9e.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_30aa145d.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00016.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006.jpg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_030ef8cc.jpeg"
            ]
          },
          {
            name: "Specialløsninger",
            service_slug: "specialloesninger",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00030.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00031.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00026.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00011.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_e982ed86.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00023.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00044.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_dd32f33a.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_d11935b1.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_66ea2138.jpeg"
            ]
          },
          {
            name: "Træterrasser",
            service_slug: "traeterrasser",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_92491bb2.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_b3b02ecb.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_d9a09e68.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_14ac3704.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_0efad239.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_b553e82f.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_69808aa9.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00008_f26a7628.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00009_8edfe86c.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00010_d7c77e58.jpeg"
            ]
          },
          {
            name: "Renovering & Ombygning",
            service_slug: "renovering-ombygning",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_33a66958.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_94350a78.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_5a18a6aa.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_0bf175a9.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_0bc330d7.jpeg"
            ]
          },
          {
            name: "Køkken & Bad",
            service_slug: "koekken-og-bad",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_5076a762.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_3923b3cf.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_0d98a9a5.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_7d6a26a5.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_7dc10f92.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_378ee18d.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00008_da9ce073.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00009_a5294310.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00010_556643cd.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00011_80aabe07.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00012_3a816736.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00013_9bbf4613.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00014_c2050757.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00015_98060b5a.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/img-1359.webp",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/img-1360.webp",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/img-1361.webp",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/img-1362.webp",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/img-1363.webp"
            ]
          },
          {
            name: "Fundament- og murerarbejde",
            service_slug: "fundament-og-murerarbejde",
            images: [
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00009_708e730d.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_cf125b87.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_bfd51c41.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_741f2636.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_7e5cecb2.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_d74a4eab.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_d4dc06a2.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_29893b90.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00008_914b3465.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_15480386.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_acbaacfb.jpeg",
              "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_380c8599.jpeg"
            ]
          },
          {
            name: "Nybyg",
            service_slug: "nybyg",
            images: []
          }
        ];
        setGalleries(fallbackGals);
      }
    }

    loadGalleries();
  }, []);

  // Filter images based on active tab
  const filteredGalleries = selectedCategory === 'alle'
    ? galleries
    : galleries.filter((g) => g.service_slug === selectedCategory);

  const displayImages = filteredGalleries.flatMap((g) => 
    (g.images || []).map((url) => ({ url, category: g.name }))
  );

  const categories = [
    { label: 'Alle Billeder', slug: 'alle' },
    { label: 'Tagarbejde', slug: 'tagarbejde' },
    { label: 'Døre & Vinduer', slug: 'doere-og-vinduer' },
    { label: 'Specialløsninger', slug: 'specialloesninger' },
    { label: 'Træterrasser', slug: 'traeterrasser' },
    { label: 'Renovering', slug: 'renovering-ombygning' },
    { label: 'Køkken & Bad', slug: 'koekken-og-bad' },
    { label: 'Fundament & Murer', slug: 'fundament-og-murerarbejde' },
    { label: 'Nybyg', slug: 'nybyg' }
  ];

  return (
    <>
      <SEOHead 
        title={`Billedgalleri - ${SITE_INFO.name}`}
        description="Se vores store samling af billeder af veludført tømrer- og snedkerarbejde. Tagrenovering, sprossede vinduer, træterrasser og egekøkkener."
      />

      {/* Header */}
      <section className="bg-stone-900 text-white py-16 sm:py-20 border-b border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-white tracking-tight">
              Billedgalleri
            </h1>
            <p className="text-stone-300 text-base sm:text-lg leading-relaxed">
              Udforsk billeder fra vores seneste tømrerprojekter. Klik på et hvilket som helst billede for at åbne det i fuld skærm.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 space-y-10">
          
          {/* Category Filter Tabs */}
          <div className="flex flex-wrap items-center gap-2 border-b border-stone-200 pb-4">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setSelectedCategory(cat.slug)}
                className={`px-4 py-2 font-heading font-semibold text-xs transition-colors cursor-pointer ${
                  selectedCategory === cat.slug
                    ? 'bg-amber-600 text-stone-950 font-bold shadow-sm'
                    : 'bg-white text-stone-700 hover:bg-stone-200 border border-stone-200'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Photo Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {displayImages.map((item, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setActiveImgIndex(idx);
                  setLightboxOpen(true);
                }}
                className="group relative h-64 overflow-hidden border border-stone-200 shadow-md cursor-pointer"
              >
                <img
                  src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/${item.url.replace('https://assets.auxodev.dk/', '')}`}
                  alt={item.category}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-stone-950/50 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center text-white p-4 text-center">
                  <ZoomIn className="w-8 h-8 text-amber-400 mb-2" aria-hidden="true" />
                  <span className="font-heading font-bold text-xs uppercase tracking-wider">{item.category}</span>
                  <span className="text-[11px] text-stone-300 mt-1">Åbn i stor visning</span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Lightbox Modal */}
      <GalleryLightboxModal
        images={displayImages.map((i) => i.url)}
        currentIndex={activeImgIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setActiveImgIndex((prev) => (prev - 1 + displayImages.length) % displayImages.length)}
        onNext={() => setActiveImgIndex((prev) => (prev + 1) % displayImages.length)}
      />

      <ContactSection />
    </>
  );
}
